import React, { Fragment } from "react";

import { Breadcrumb } from "semantic-ui-react";
import ObjectLink from "./ObjectLink";

const ObjectBreadcrumb = ({ object, includeCollection }) => {
  const includeCollection_ = includeCollection || true;

  if (!object) {
    return null;
  }

  const sections = [
    {
      key: "object",
      content: <ObjectLink id={object.ID[0]}>{object.ID[0]}</ObjectLink>,
      active: true
    }
  ];

  if (object.PARENT && object.PARENT.length > 0) {
    sections.unshift({
      key: "parent",
      content: (
        <Fragment>
          <ObjectLink id={object.PARENT[0]}>{object.PARENT[0]}</ObjectLink>
        </Fragment>
      )
    });
  }

  if (includeCollection_) {
    sections.unshift({
      key: "collection",
      content: object.HIM[0],
      link: false
    });
  }

  return <Breadcrumb icon="right angle" sections={sections} />;
};

export default ObjectBreadcrumb;
